import { useEffect, useState } from 'react';
import { checkIsAdmin } from '../lib/admin';

/**
 * Server-authoritative "is this viewer admin" check (not the role-lens
 * `useIsAdmin`, which reflects the active persona, not a real capability).
 * Pages reachable by both `admin` and the read-only `ai_operator` role
 * (`AdminOrAiOperatorRoute`) use this to hide mutation UI — defaults to
 * `false` until resolved, so a slow/failed check never shows a button an
 * `ai_operator` viewer shouldn't see.
 */
export function useIsAdminViewer(): boolean {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    let cancelled = false;
    checkIsAdmin().then((ok) => {
      if (!cancelled) setIsAdmin(ok);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return isAdmin;
}
